export const getClientDevice = () => {
  if (typeof window === 'undefined') return 'unknown';

  const ua = navigator.userAgent;

  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true;

  const isWebView = /wv|WebView/i.test(ua);

  if (isAndroid && isStandalone) return 'android-pwa';
  if (isIOS && isStandalone) return 'ios-pwa';
  if (isAndroid && isWebView) return 'android-webview';
  if (isAndroid) return 'android-browser';
  if (isIOS) return 'ios-browser';

  return 'desktop';
};
